const hasLocationFooter = document.querySelector(".footer-location");

if (hasLocationFooter) {
    document.documentElement.classList.add('-has-location-footer');
}
